module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "m-b-sm"
  }, [_vm._v("人才对比")]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 p-b-sm"
  }, [_c('radar', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "title": _vm.radar_data.title,
      "legend": _vm.radar_data.legend,
      "series": _vm.radar_data.series,
      "indicator": _vm.radar_data.indicator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "compare-table",
    attrs: {
      "border": "1"
    }
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('th', {
      key: record._id
    }, [_c('div', {
      staticClass: "p-t-b-xs text-left"
    }, [_vm._v("姓名：" + _vm._s(record.evaluate_invitation.realname))]), _vm._v(" "), _c('div', {
      staticClass: "p-t-b-xs text-left"
    }, [_vm._v("手机：" + _vm._s(record.evaluate_invitation.phone))]), _vm._v(" "), _c('div', {
      staticClass: "p-t-b-xs text-left"
    }, [_vm._v("岗位：" + _vm._s(record._questionnaire.name))]), _vm._v(" "), _c('div', {
      staticClass: "p-t-b-xs text-center"
    }, [_c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          'name': 'EvaluateReport',
          params: {
            'code': record._id
          }
        },
        "tag": "a",
        "target": "_blank"
      }
    }, [_vm._v("详情")])], 1)])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-title",
    attrs: {
      "colspan": 2 + _vm.records.length
    }
  }, [_vm._v("测评概况")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "yaxis",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("综合得分")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('td', {
      key: record._id,
      class: {
        'lower': record.abilities_score == _vm.preview.score.min, 'higher': record.abilities_score == _vm.preview.score.max
      }
    }, [_vm._v("\n              " + _vm._s(record.abilities_score.toFixed(2)) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "yaxis",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("答题时间(分)")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('td', {
      key: record._id,
      class: {
        'lower': record.duration == _vm.preview.duration.min, 'higher': record.duration == _vm.preview.duration.max
      }
    }, [_vm._v("\n              " + _vm._s((record.duration / 60000).toFixed(2)) + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "yaxis",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("求职人员排名")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('td', {
      key: record._id,
      class: {
        'lower': record.ability_rate == _vm.preview.rate.min, 'higher': record.ability_rate == _vm.preview.rate.max
      }
    }, [_vm._v("\n              " + _vm._s('领先' + (record.ability_rate * 100).toFixed(2) + '%') + "\n            ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "yaxis",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("入职员工排名")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('td', {
      key: record._id,
      class: {
        'lower': record.entry_rate == _vm.preview.entry_rate.min, 'higher': record.entry_rate == _vm.preview.entry_rate.max
      }
    }, [_vm._v("\n              " + _vm._s('领先' + ((record.entry_rate || 0) * 100).toFixed(2) + '%') + "\n            ")])
  })], 2)]), _vm._v(" "), _vm._l((_vm.abilities), function(ability, key) {
    return _c('tbody', {
      key: key,
      staticClass: "p-b-sm"
    }, [_c('tr', [_c('td', {
      staticClass: "table-title",
      attrs: {
        "colspan": 2 + _vm.records.length
      }
    }, [_vm._v(_vm._s(ability.name || ' '))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "yaxis",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("得分")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
      return _c('td', {
        key: record._id,
        class: {
          'lower': record.abilities[key] && record.abilities[key].score == ability.score.min, 'higher': record.abilities[key] && record.abilities[key].score == ability.score.max
        }
      }, [_vm._v("\n              " + _vm._s(record.abilities[key] ? record.abilities[key].score.toFixed(2) : '-') + "\n            ")])
    })], 2), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "yaxis",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("求职人员排名")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
      return _c('td', {
        key: record._id,
        class: {
          'lower': record.abilities[key] && record.abilities[key].rate == ability.rate.min, 'higher': record.abilities[key] && record.abilities[key].rate == ability.rate.max
        }
      }, [_vm._v("\n              " + _vm._s(record.abilities[key] ? ("领先" + ((record.abilities[key].rate*100).toFixed(2)) + "%") : '-') + "\n            ")])
    })], 2), _vm._v(" "), _vm._l((ability.indicators), function(indicator, indicatorId) {
      return [_c('tr', {
        key: indicator._id
      }, [_c('td', {
        staticClass: "yaxis",
        attrs: {
          "rowspan": "3"
        }
      }, [_vm._v(_vm._s(indicator.name || " "))]), _vm._v(" "), _c('td', [_vm._v("得分")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
        return _c('td', {
          key: record._id,
          class: {
            'lower': record.indicators[indicatorId] && record.indicators[indicatorId].score == indicator.score.min, 'higher': record.indicators[indicatorId] && record.indicators[indicatorId].score == indicator.score.max
          }
        }, [_vm._v("\n                " + _vm._s(record.indicators[indicatorId] ? record.indicators[indicatorId].score.toFixed(2) : '-') + "\n              ")])
      })], 2), _vm._v(" "), _c('tr', {
        key: indicator._id
      }, [_c('td', [_vm._v("耗时(分)")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
        return _c('td', {
          key: record._id,
          class: {
            'lower': record.indicators[indicatorId] && record.indicators[indicatorId].duration == indicator.duration.min, 'higher': record.indicators[indicatorId] && record.indicators[indicatorId].duration == indicator.duration.max
          }
        }, [_vm._v("\n                " + _vm._s(record.indicators[indicatorId] ? (record.indicators[indicatorId].duration / 60000).toFixed(2) : '-') + "\n              ")])
      })], 2), _vm._v(" "), _c('tr', {
        key: indicator._id
      }, [_c('td', [_vm._v("求职人员排名")]), _vm._v(" "), _vm._l((_vm.records), function(record) {
        return _c('td', {
          key: record._id,
          class: {
            'lower': record.indicators[indicatorId] && record.indicators[indicatorId].rate == indicator.rate.min, 'higher': record.indicators[indicatorId] && record.indicators[indicatorId].rate == indicator.rate.max
          }
        }, [_vm._v("\n                " + _vm._s(record.indicators[indicatorId] ? ("领先" + ((record.indicators[indicatorId].rate*100).toFixed(2)) + "%") : '-') + "\n              ")])
      })], 2)]
    })], 2)
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "yaxis",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "p-t-b-xs text-left lower strong"
  }, [_vm._v("* 绿色表示低位数值")]), _vm._v(" "), _c('div', {
    staticClass: "p-t-b-xs text-left higher strong"
  }, [_vm._v("* 红色表示高位数值")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296bb2a1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/compare.vue
// module id = 470
// module chunks = 1